import React, { useState, useEffect } from "react";



import { useNavigate, Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import db from "./Firebase";
import { storage } from './Firebase';
import { collection, doc, getDoc, updateDoc, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Accordion, Button, Table, Container, Modal, Form } from "react-bootstrap";
import * as XLSX from "xlsx"; // Import XLSX for Excel export


function QueryData() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchType, setSearchType] = useState(""); // State for filtering by type

    useEffect(() => {
        db.collection("nv_course_enquiry").orderBy("created_date", "desc").onSnapshot((snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });
    }, []);

    // // **Toggle Status in Firestore**
    // const handleStatusChange = async (id, currentStatus, query, phone) => {
    //     const newStatus = currentStatus === 1 ? 0 : 1; // Toggle between 1 (Resolved) & 0 (Pending)
    //     try {
    //         const queryRef = doc(db, "nv_course_enquiry", id);
    //         await updateDoc(queryRef, { status: newStatus });

    //         // 1️⃣ Fetch username from personal_details where phone_no = uploadData.phoneNo
    //         const querySnapshot = await getDocs(
    //             query(collection(db, "personal_details"), where("phone_no", "==", phone))
    //         );


    //         if (querySnapshot.empty) {
    //             alert("User not found!");
    //             return;
    //         }

    //         let username = "";
    //         querySnapshot.forEach((doc) => {
    //             username = doc.data().username; // Get username
    //         });


    //         // 2️⃣ Now create entry in nv_notifications
    //         await addDoc(collection(db, "nv_notifications"), {
    //             actions: false,
    //             category: "Alert",
    //             created_at: new Date(),
    //             image: "",
    //             is_download: "",
    //             is_join: "",
    //             redirect_page: "",
    //             requested_phone_no: phone,
    //             requested_user: username,
    //             seen_by: [],
    //             status: "1",
    //             timestamp: new Date(),
    //             title: `Your issue "${query}" has been resolved. Thank you for your patience!`,
    //             type: "private",
    //             user_id: username, // ✅ Use username as user_id
    //             id: new Date().getTime() + new Date().getMilliseconds()
    //         });

    //         // **Update UI Immediately**
    //         setData((prevData) =>
    //             prevData.map((record) =>
    //                 record.id === id ? { ...record, data: { ...record.data, status: newStatus } } : record
    //             )
    //         );
    //     } catch (error) {
    //         console.error("Error updating status:", error);
    //     }
    // };



    const handleStatusChange = async (id, currentStatus, issueQuery, phone) => { // ✅ Renamed "query" to "issueQuery"
        if (currentStatus === 0) { // ✅ Only show confirmation when resolving
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Do you want to resolve this issue?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, resolve it!",
                cancelButtonText: "Cancel",
            });

            if (!result.isConfirmed) {
                return; // ❌ Do nothing if user cancels
            }
        }

        const newStatus = currentStatus === 1 ? 0 : 1; // Toggle between 1 (Resolved) & 0 (Pending)

        try {
            const queryRef = doc(db, "nv_course_enquiry", id);
            await updateDoc(queryRef, { status: newStatus });

            // 1️⃣ Fetch username from personal_details where phone_no = phone
            const userQuery = query(collection(db, "personal_details"), where("phone_no", "==", phone)); // ✅ Fixed query usage
            const querySnapshot = await getDocs(userQuery);

            if (querySnapshot.empty) {
                Swal.fire("Error!", "User not found!", "error");
                return;
            }

            let username = "";
            querySnapshot.forEach((doc) => {
                username = doc.data().username; // Get username
            });

            // 2️⃣ Create an entry in nv_notifications
            await addDoc(collection(db, "nv_notifications"), {
                actions: false,
                category: "Alert",
                created_at: new Date(),
                image: "",
                is_download: "",
                is_join: "",
                redirect_page: "",
                requested_phone_no: phone,
                requested_user: username,
                seen_by: [],
                status: "1",
                timestamp: new Date(),
                title: `Your issue "${issueQuery}" has been resolved. Thank you for your patience!`, // ✅ Used renamed "issueQuery"
                type: "private",
                user_id: username,
                id: new Date().getTime() + new Date().getMilliseconds()
            });

            // ✅ Show success alert after updating Firestore
            Swal.fire("Resolved!", "The issue has been marked as resolved.", "success");

            // **Update UI Immediately**
            setData((prevData) =>
                prevData.map((record) =>
                    record.id === id ? { ...record, data: { ...record.data, status: newStatus } } : record
                )
            );
        } catch (error) {
            console.error("Error updating status:", error);
            Swal.fire("Error!", "Something went wrong. Please try again.", "error");
        }
    };



    // **Filter Data Based on Search Query and Type**
    const filteredData = data.filter((record) => {
        const matchesPhone = record.data.phone_no.includes(searchQuery);
        const matchesType = searchType === "" || record.data.type.toLowerCase().includes(searchType.toLowerCase());
        return matchesPhone && matchesType;
    });

    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3">
                    <h6 className="mb-2">Query Data Page - (Count: {filteredData.length})</h6>
                </div>

                {/* Search Inputs */}
                <div className="mb-3 d-flex gap-2">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search by phone no..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ width: "250px" }}
                    />

                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search by type..."
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={{ width: "250px" }}
                    />
                </div>

                {/* Table */}
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Type</th>
                                <th>Query</th>
                                <th>W/C</th>
                                <th>Created Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map(({ id, data }, index) => (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td>{data.username}</td>
                                    <td>{data.phone_no}</td>
                                    <td>{data.type}</td>
                                    <td>{data.query}</td>
                                    <td>{data.course_id}</td>
                                    <td>{moment(data.created_date.toDate()).format("DD/MM/YY, h:mm a")}</td>
                                    <td>
                                        <Button
                                            variant={data.status === 1 ? "success" : "danger"}
                                            size="sm"
                                            onClick={() => handleStatusChange(id, data.status, data.query, data.phone_no)}
                                            disabled={data.status === 1} // ✅ Disable button when resolved
                                        >
                                            {data.status === 1 ? "Resolved" : "Pending"}
                                        </Button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default QueryData;



// import React, { useState, useEffect } from "react";


// import { Link } from "react-router-dom";
// import db from "./Firebase";
// import Moment from "moment";
// import { extendMoment } from "moment-range";

// function QueryData() {
//     const moment = extendMoment(Moment);
//     const [data, setData] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [searchType, setSearchType] = useState(""); // State for filtering by type

//     useEffect(() => {
//         db.collection("nv_course_enquiry").orderBy("created_date", "desc").onSnapshot((snapshot) => {
//             setData(
//                 snapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     data: doc.data(),
//                 }))
//             );
//         });
//     }, []);

//     // **Filter Data Based on Search Query and Type**
//     const filteredData = data.filter((record) => {
//         const matchesPhone = record.data.phone_no.includes(searchQuery);
//         const matchesType = searchType === "" || record.data.type.toLowerCase().includes(searchType.toLowerCase());

//         return matchesPhone && matchesType;
//     });

//     return (
//         <>
//             <div className="p-2 d-flex justify-content-between">
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>

//             <div className="p-3">
//                 <div className="card-header pb-0 px-3">
//                     <h6 className="mb-2">Query Data Page - (Count: {filteredData.length})</h6>
//                 </div>

//                 {/* Search Inputs */}
//                 <div className="mb-3 d-flex gap-2">
//                     <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         placeholder="Search by phone no..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         style={{ width: "250px" }}
//                     />

//                     <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         placeholder="Search by type..."
//                         value={searchType}
//                         onChange={(e) => setSearchType(e.target.value)}
//                         style={{ width: "250px" }}
//                     />
//                 </div>

//                 {/* Table */}
//                 <div className="table-responsive fix-width scroll-inner">
//                     <table className="table table-bordered table-hover">
//                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                             <tr>
//                                 <th>Sr. No</th>
//                                 <th>Name</th>
//                                 <th>Phone No</th>
//                                 <th>Type</th>
//                                 <th>Query</th>
//                                 <th>W/C</th>
//                                 <th>Created Date</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map(({ id, data }, index) => (
//                                 <tr key={id}>
//                                     <td>{index + 1}</td>
//                                     <td>{data.username}</td>
//                                     <td>{data.phone_no}</td>
//                                     <td>{data.type}</td>
//                                     <td>{data.query}</td>
//                                     <td>{data.course_id}</td>
//                                     <td>{moment(data.created_date.toDate()).format("DD/MM/YY, h:mm a")}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default QueryData;


// // import React, { useState, useEffect } from "react";


// // import { useNavigate, Link, useParams } from 'react-router-dom';
// // import Swal from 'sweetalert2'
// // import db from "./Firebase";
// // import { storage } from './Firebase';
// // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // import Moment from 'moment';
// // import { extendMoment } from 'moment-range';

// // function QueryData() {

// //     const moment = extendMoment(Moment);
// //     const [data, setData] = useState([]);
// //     const [searchQuery, setSearchQuery] = useState("");


// //     useEffect(() => {
// //         db.collection("nv_course_enquiry").orderBy("created_date", "desc").onSnapshot((snapshot) => {
// //             setData(
// //                 snapshot.docs.map((doc) => ({
// //                     id: doc.id,
// //                     data: doc.data(),
// //                 }))
// //             );
// //         });

// //     }, []);

// //     // Step 3: Filter data based on search query and availability filter
// //     const filteredData = data.filter((record) => {
// //         return (
// //             record.data.phone_no.includes(searchQuery)
// //         );
// //     });



// //     const handleSearch = (e) => {
// //         setSearchQuery(e.target.value); // Step 3: Update search query state
// //     }


// //     return (
// //         <>
// //             <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
// //                 <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

// //             </div>

// //             <div class="p-3">

// //                 <div class="card-header pb-0 px-3">
// //                     <h6 class="mb-2">Query Data Page - (Count : {data.length})</h6>
// //                 </div>
// //                 <input
// //                     type="text"
// //                     className="form-control form-control-sm mb-2"
// //                     placeholder="Search by phone no..."
// //                     value={searchQuery}
// //                     onChange={handleSearch}
// //                 />


// //                 <div class="table-responsive fix-width scroll-inner">
// //                     <table class="table table-bordered table-hover">
// //                         <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
// //                             <tr>
// //                                 <th>Sr. No</th>
// //                                 <th>Name</th>
// //                                 <th>Phone No</th>
// //                                 <th>Type</th>
// //                                 <th>Query</th>
// //                                 <th>W/C</th>
// //                                 <th>Created Date</th>
// //                             </tr>
// //                         </thead>
// //                         <tbody>
// //                             {filteredData?.map(({ id, data }, index) => (
// //                                 <>
// //                                     <tr>
// //                                         <td>{index + 1}</td>
// //                                         <td>{data.username}</td>
// //                                         <td>{data.phone_no}</td>
// //                                         <td>{data.type}</td>
// //                                         <td>{data.query}</td>
// //                                         <td>{data.course_id}</td>
// //                                         <td>{moment(data.created_date.toDate()).format("DD/MM/YY, h:mm a")}</td>
// //                                     </tr>
// //                                 </>
// //                             ))}


// //                         </tbody>
// //                     </table>
// //                 </div>
// //             </div>



// //         </>
// //     )
// // }

// // export default QueryData